"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _menu = require("@/api/menu/menu");
var _index = _interopRequireDefault(require("@/components/selectTree/index"));
var _iconf = require("@/icons/iconf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      addForm: {
        type: 1,
        icon: "",
        router: "",
        component: "",
        sort: 0,
        parentId: "",
        alwaysShow: 0,
        hidden: 0,
        breadCrumb: 0,
        noCache: 0,
        names: ""
      },
      editForm: {
        id: "",
        type: "",
        icon: "",
        router: "",
        component: "",
        sort: 0,
        parentId: "",
        alwaysShow: 0,
        hidden: 0,
        breadCrumb: 0,
        noCache: 0,
        names: ""
      },
      editDia: false,
      addDia: false,
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [],
      funBtns: [{
        size: "small",
        click: "unLock",
        icon: "el-icon-upload",
        name: "上传静态资源",
        type: "primary"
      }, {
        size: "small",
        click: "handleAdd",
        icon: "el-icon-circle-plus-outline",
        name: "新增",
        type: "danger"
      }],
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      labelList: [{
        prop: "name",
        label: "菜单名称",
        width: "180"
      }, {
        prop: "icon",
        label: "图标",
        width: "180"
      }, {
        prop: "sort",
        label: "排序",
        width: "80"
      }, {
        prop: "type",
        label: "类型",
        width: "150"
      }, {
        prop: "uniqueCode",
        label: "编码",
        width: "180"
      }, {
        prop: "id",
        label: "id",
        width: "180"
      }, {
        prop: "router",
        label: "路由路径",
        width: "180"
      }],
      tableData: [],
      elItem: "",
      iconList: _iconf.iconList
    };
  },
  // el-icon-edit
  methods: {
    // 模糊搜索
    search: function search(e) {
      console.log(e);
    },
    // 修改提交
    submitEdit: function submitEdit() {
      var _this = this;
      (0, _menu.menuEdit)(this.editForm).then(function (res) {
        console.log(res);
        if (res.code === 2000) {
          _this.$message.success("操作成功。");
          _this.editDia = false;
          _this.editForm = {
            id: "",
            type: "",
            icon: "",
            router: "",
            component: "",
            sort: 0,
            parentId: "",
            alwaysShow: 0,
            hidden: 0,
            breadCrumb: 0,
            noCache: 0,
            names: ""
          };
          _this.getMenuTree();
        }
      });
    },
    // 新增提交
    submitAdd: function submitAdd() {
      var _this2 = this;
      if (this.elItem) {
        this.addForm.parentId = this.elItem;
      }
      (0, _menu.menuAdd)(this.addForm).then(function (res) {
        if (res.code === 2000) {
          _this2.elItem = "";
          _this2.addForm = {
            type: 1,
            icon: "",
            router: "",
            component: "",
            sort: 0,
            parentId: "",
            alwaysShow: 0,
            hidden: 0,
            breadCrumb: 0,
            noCache: 0,
            names: ""
          };
          _this2.$message.success("操作成功。");
          _this2.addDia = false;
          _this2.getMenuTree();
        }
      });
    },
    // 新增按钮
    handleAdd: function handleAdd(e) {
      if (e) {
        this.elItem = e.id;
      }
      this.addDia = true;
    },
    // 编辑按钮
    handleEdit: function handleEdit(e) {
      var _this3 = this;
      (0, _menu.getMenuById)({
        id: e.id
      }).then(function (res) {
        _this3.editForm = res.data;
        _this3.editDia = true;
      });
    },
    // 删除菜单
    handleDel: function handleDel(e) {
      var _this4 = this;
      (0, _menu.menuDel)({
        id: e.id
      }).then(function (res) {
        if (res.code === 2000) {
          _this4.getMenuTree();
          _this4.$message.success("操作成功。");
        }
      });
    },
    // 获取菜单树结构
    getMenuTree: function getMenuTree() {
      var _this5 = this;
      (0, _menu.menuTree)().then(function (res) {
        var data = res.data;
        _this5.tableData = data;
      });
    },
    // 新增
    saveBureau: function saveBureau() {
      this.$router.push("/test/school-add");
    },
    handleClose: function handleClose(done) {
      done();
    }
  },
  created: function created() {
    this.getMenuTree();
    this.defaultCheckedKeys = [1000];
  },
  mounted: function mounted() {
    this.defaultCheckedKeys = [1001];
  },
  components: {
    TreeSelect: _index.default,
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};